module.exports = __webpack_public_path__ + "static/media/expedia.ea68d35e.svg";